import { gql } from '@apollo/client'

export const UPDATE_ORDER_PERMISSIONS = gql`
  mutation OrderPermissionsByType(
    $typePermiss: String!
    $idTypePermiss: Int!
    $input: [OrderModuleInput!]!
  ) {
    orderPermissionsByType(
      typePermiss: $typePermiss
      idTypePermiss: $idTypePermiss
      input: $input
    )
  }
`
